import React, { useState, useEffect } from "react";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../../axios";
import axios from "axios";
import { Loading } from "../Loading";
import ChapterDocument from "../../Courses/CourseDetails/CourseChapterDetails/chapterDocument";
import { countryData } from "../../../_constants/staticData";
import SignupOverlay from "../../Login/SignupOverlay";
import { validateFirstName } from "../../../_helpers";
import useAnalyticsEventTracker from "../useAnalyticsEventTracker";
// import confirmImg from "../../Other/assets/confirm.png";

const ConfirmationModal = ({
  closeHandler,
  bookDemoHandler,
  planStatus,
  setManageConfirmation,
  comeFrom
}) => {
  const navigate = useNavigate();
  const [AccountDetails, setAccountDetails] = useState({
    createAccount: false,
    Signup: false,
  });
  const [error, setError] = useState();
  const [popUp, setPopUp] = useState(false);
  const [responsePopup, setResponsePopup] = useState(false);

  const [isLoading, setisLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showPassword, setshowPassword] = useState({
    password: false,
    confirmPassword: false,
  });
  const [response, setResponse] = useState();
  const handleStudentRoute = () => {
    navigate("/login");
  };
  const [licenseData, setLicenseData] = useState("");
  const [printCertificate, setPrintCertificate] = useState(false);
  const [validateFname, setValidateFname] = useState(false);
  const [validateLname, setValidateLname] = useState(false);
  const [validateUname, setValidateUname] = useState(false);
  const [validateUEmail, setValidateUEmail] = useState(false);
  const [validateUPassword, setValidateUPassword] = useState(false);
  const [validateUPhoneNumber, setValidateUPhoneNumber] = useState(false);

  const [checkLicense, setCheckLicense] = useState(false);
  const [termsAndServicesPolicy, setTemsAndServicePolicy] = useState({
    ageConfirmation: false,
    privacyNotice: false,
  });

  const [details, setDetails] = useState({
    role: 3,
    firstName: "",
    lastName: "",
    email: "",
    userName: "",
    phoneNumber: "",
    city: "",
    country: "",
    state: "",
    password: "",
    confirmPassword: "",
    OrganisationName: "",
    pincode: null,
    OrganisationType: "",
    street: "",
  });

  const handleInputChange = (event) => {
    event.preventDefault();

    const { name, value } = event.target;
    setDetails((values) => ({
      ...values,
      [name]: value,
    }));
  };

  const gaEventTracker = useAnalyticsEventTracker("Banner", "SignUp with Pricing Banner", "SIGNUP_SUCCESS_PRICING_BANNER");
  const gaEventTracker2 = useAnalyticsEventTracker("Banner", "SignUp with Pricing Banner", "SIGNUP_FAILED_PRICING_BANNER");


  useEffect(() => {
    if (error?.success === true) {
      setLoad(true);
      const signup = async () => {
        try {
          const res = await axiosInstance.post("/sign-up", {
            role: Number(details.role),
            firstName: details.firstName,
            selectedPlan: planStatus,
            lastName: details.lastName,
            email: details.email,
            userName: details.userName,
            phoneNumber: details.phoneNumber,
            city: details.city,
            countryCode: details.country,
            state: details.state,
            password: details.password,
            confirmPassword: details.confirmPassword,
            OrganisationName: details.OrganisationName,
            pincode: Number(details.pincode),
            OrganisationType: details.OrganisationType,
            agreementAccepted: checkLicense,
            street: details.street,
            bio: "Default bio for ",
            profilePhoto:
              "https://images.unsplash.com/photo-1629648468144-5e9403a0916d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=763&q=80",
          });
          if (!res.data.error) {
            setPopUp(true);
            setLoad(false);
            if (comeFrom) {
              gaEventTracker();
            }
          } else {
            setResponse(res.data.message);
            setResponsePopup(true);
            setLoad(false);
            if (comeFrom) {
              gaEventTracker2();
            }
          }
        } catch (err) {
          if (comeFrom) {
            gaEventTracker2();
          }
          console.log(err);
          setLoad(false);
        }
      };
      signup();
    }
  }, [error]);


  const validateFirstName = (e) => {
    const firstName = /^[A-Za-z]+$/;
    return firstName.test(e.target.value)
      ? setValidateFname(true)
      : setValidateFname(false);
  };

  const validateLastName = (e) => {
    const lastName = /^[A-Za-z]+$/;
    return lastName.test(e.target.value)
      ? setValidateLname(true)
      : setValidateLname(false);
  };


  const validateUserName = (e) => {
    const userName = /^(?=.*?[a-z])(?=.*[A-Z])(?=.*?[0-9]).{5,}$/;
    return userName.test(e.target.value)
      ? setValidateUname(true)
      : setValidateUname(false);
  };
  const validateUserEmail = (e) => {
    const email = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    return email.test(e.target.value)
      ? setValidateUEmail(true)
      : setValidateUEmail(false);
  };

  const validateUserPassword = (e) => {
    const password =
      /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9])(?=.*[@#$-%^&+=\-])([\w.\-]).*$/;

    return password.test(e.target.value)
      ? setValidateUPassword(true)
      : setValidateUPassword(false);
  };

  const validateUserPhoneNumber = (e) => {
    const phoneNumber =
      /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    return phoneNumber.test(e.target.value)
      ? setValidateUPhoneNumber(true)
      : setValidateUPhoneNumber(false);
  };

  const validate = () => {
    let error = {};

    if (!details.firstName) {
      error.firstName = "Please enter first name";
    } else if (!validateFname) {
      error.firstName2 = "Invalid first name, please enter valid firstname";
    } else if (!details.lastName) {
      error.lastName = "Please enter last name";
    } else if (!validateLname) {
      error.lastName2 = "Invalid last name, please enter valid lastname";
    } else if (!details.email) {
      error.email = "Please enter email address";
    } else if (!validateUEmail) {
      error.email2 = "Invalid email address, please enter valid email address";
    } else if (!details.userName) {
      error.userName = "Please enter username";
    } else if (!validateUname) {
      error.userName2 =
        "username must have more than 5 characters & contains at least one capital letter, and number";
    } else if (!details.password) {
      error.password = "Please enter password";
    } else if (!validateUPassword) {
      error.password2 =
        "password must have at least 8 characters long, contains at least one number (0-1) and have at least one uppercase letter (A-Z) and one special character (@#$-%^&+=-)";
    } else if (details.confirmPassword !== details.password) {
      error.confirmPassword = "Password and confirm password are not same ";
    } else if (!details.country) {
      error.country = "Please enter country name";
    } else if (!details.state) {
      error.state = "Please enter State Name";
    } else if (!details.OrganisationName) {
      error.organisationName = "Please enter organisation name";
    } else if (!details.OrganisationType) {
      error.OrganisationType = "Please select organisation type";
    } else if (!details.phoneNumber) {
      error.phoneNumber = "Please enter mobile/cell number";
    } else if (!validateUPhoneNumber) {
      error.phoneNumber2 =
        "Invalid mobile/cell number, please enter valid mobile/cell number.";
    } else if (!details.city) {
      error.city = "Please enter city name";
    } else if (!details.pincode) {
      error.pincode = "Please enter pincode";
    } else if (!details.street) {
      error.street = "Please enter street address";
    } else if (!details.role) {
      error.role = "Please select your role";
    } else if (details) {
      error.success = true;
    }
    setError(error);
  };

  const handleAccept = (e) => {
    const { checked } = e.target;
    setCheckLicense(checked);
    if (
      checked &&
      details.firstName &&
      details.lastName &&
      details.email &&
      details.phoneNumber
    ) {
      setisLoading(true);
      try {
        axios
          .post(
            `${process.env.REACT_APP_LOGIN_API_BASEURL}/sign-up/pdf-agreement`,
            JSON.stringify({
              firstName: details.firstName,
              lastName: details.lastName,
              email: details.email,
              phoneNumber: details.phoneNumber,
              street: details.street,
              city: details.city,
              state: details.state,
              country: details.country,
              agreementAccepted: true,
            }),
            {
              headers: {
                "Content-Type": "application/json",
              },
              responseType: "blob",
            }
          )
          .then((res) => {
            var blob = new Blob([res.data], { type: "application/pdf" });
            var file = window.URL.createObjectURL(blob);
            setLicenseData(file);
            setPrintCertificate(true);
            setisLoading(false);
          })
          .catch((res) => {
            console.log(res);
            setisLoading(false);
          });
      } catch (error) {
        console.log(error);
        setisLoading(false);
      }
    } else {
      validate();
    }
  };

  const handleAccountDetails = (property) => {
    setAccountDetails({ ...AccountDetails, [property]: true });
  };

  const registrationHandler = () => {
    if (
      termsAndServicesPolicy.ageConfirmation &&
      termsAndServicesPolicy.privacyNotice
    ) {
      setAccountDetails({
        ...AccountDetails,
        createAccount: false,
        Signup: true,
      });
    }
  };

  const showHandler = () => {
    setPrintCertificate(!printCertificate);
  };

  const handlePassword = (toggle) => {
    if (toggle === "password") {
      setshowPassword({ ...showPassword, [toggle]: !showPassword[toggle] });
    } else {
      setshowPassword({ ...showPassword, [toggle]: !showPassword[toggle] });
    }
  };

  const accountStatusCloseHandler = () => {
    setResponsePopup(false);
  };

  // const isCreateAccount =
  //   !AccountDetails.createAccount && !AccountDetails.Signup;

  return (
    <div className="pricing_overlay">
      <OverlayContainer>
        <div
          // className={`inner-overlay ${
          //   isCreateAccount ? "create-account" : "termsMain_container"
          // }`}
          className={"inner-overlay termsMain_container"}
        >
          <div className="close-wrapper" onClick={() => closeHandler()}>
            <div>
              <i className="icon check" />
            </div>
          </div>
          {!AccountDetails.createAccount && !AccountDetails.Signup && (
            <div>
              {/* <div className="header">
                <div className="header-img">
                  <img src={confirmImg} />
                </div>
              </div> */}
              <div className="">
                <button
                  onClick={() => handleAccountDetails("createAccount")}
                  className="quiz-submit-btn-new"
                >
                  Create account
                </button>
                <button
                  onClick={handleStudentRoute}
                  className="quiz-submit-btn-new-1"
                >
                  Login
                </button>
              </div>
              <div className="title lmsStatus">Are you looking for LMS ?</div>
              <button onClick={bookDemoHandler} className="quiz-submit-btn-new">
                LMS
              </button>
            </div>
          )}
          {AccountDetails.createAccount && (
            <div>
              <div className="terms-Serives">
                <h3>Terms And Services</h3>
                <p>
                  We have outlined the Transfer of Data to yslearn’s Data
                  Services in the Privacy Notice
                </p>
              </div>

              <div className="flex-ew-0">
                <input
                  type="checkbox"
                  id="one"
                  style={{ width: "auto" }}
                  value={termsAndServicesPolicy.ageConfirmation}
                  onChange={() =>
                    setTemsAndServicePolicy({
                      ...termsAndServicesPolicy,
                      ageConfirmation: !termsAndServicesPolicy.ageConfirmation,
                    })
                  }
                />
                <label htmlFor="one">I confirm that I am 18 years or older.</label>
              </div>

              <div className="flex-ew-0">
                <input
                  id="three"
                  type="checkbox"
                  style={{ width: "auto" }}
                  value={termsAndServicesPolicy.privacyNotice}
                  onChange={() =>
                    setTemsAndServicePolicy({
                      ...termsAndServicesPolicy,
                      privacyNotice: !termsAndServicesPolicy.privacyNotice,
                    })
                  }
                />

                <label htmlFor="three">
                  I agree to the{" "}
                  <a href="/privacy" target="_blank">
                    yslearn's Privacy Notice.
                  </a>
                </label>
              </div>
              <div className="flex-ew-0">
                <button
                  onClick={registrationHandler}
                  className="quiz-submit-btn"
                >
                  Submit
                </button>
              </div>
            </div>
          )}
          {AccountDetails.Signup && (
            <div>
              {responsePopup && (
                <div className="quiz-eveny-0 responseSignup">
                  <div onClick={accountStatusCloseHandler}>X</div>
                  <p style={{ marginBottom: "0px", margintop: "25px" }}>
                    {response}
                  </p>
                </div>
              )}

              <div className="contact-upper">
                <span className="registrationHeader">
                  Enter your details to create a new account
                </span>
              </div>
              <div className="purchaseRegistration">
                <div>
                  <label>First name*</label>
                  <input
                    type="text"
                    name="firstName"
                    value={details.firstName}
                    onChange={(e) => {
                      handleInputChange(e);
                      validateFirstName(e);
                    }}
                    style={{ padding: "7px" }}
                  />
                  {!details.firstName ? (
                    <span>{error?.firstName}</span>
                  ) : (
                    validateFname === false && (
                      <span>{error?.firstName2}</span>
                    )
                  )}
                </div>
                <div>
                  <label>Last name* </label>
                  <input
                    type="text"
                    name="lastName"
                    value={details.lastName}
                    onChange={(e) => {
                      handleInputChange(e);
                      validateLastName(e);
                    }}
                    style={{ padding: "7px" }}
                  />
                  {!details.lastName ? (
                    <span>{error?.lastName}</span>
                  ) : (
                    validateLname === false && (
                      <span>{error?.lastName2}</span>
                    )
                  )}
                </div>
              </div>

              <div className="purchaseRegistration">
                <div>
                  <label>Email address*</label>
                  <input
                    type="text"
                    name="email"
                    value={details.email}
                    onChange={(e) => {
                      handleInputChange(e);
                      validateUserEmail(e);
                    }}
                    style={{ padding: "7px" }}
                  />
                  {!details.email ? (
                    <span>{error?.email}</span>
                  ) : (
                    validateUEmail === false && <span>{error?.email2}</span>
                  )}{" "}
                </div>
                <div>
                  <label>User name* </label>
                  <input
                    type="text"
                    name="userName"
                    value={details.userName}
                    autoComplete="off"
                    onChange={(e) => {
                      handleInputChange(e);
                      validateUserName(e);
                    }}
                    style={{ padding: "7px" }}
                  />
                  {!details.userName ? (
                    <span>{error?.userName}</span>
                  ) : (
                    validateUname === false && <span>{error?.userName2}</span>
                  )}
                </div>
              </div>

              <div className="purchaseRegistration">
                <div>
                  <label>Password*</label>
                  <div className="form-password">
                    <input
                      name="password"
                      autoComplete="new-password"
                      value={details.password}
                      type={`${showPassword.password ? "text" : "password"}`}
                      onChange={(e) => {
                        handleInputChange(e);
                        validateUserPassword(e);
                      }}
                      style={{ padding: "7px" }}
                    />
                    <i
                      onClick={() => handlePassword("password")}
                      className={`icon ${showPassword.password
                        ? "icon-view-password-active"
                        : "icon-view-password"
                        }`}
                    ></i>
                  </div>
                  {!details.password ? (
                    <span>{error?.password}</span>
                  ) : (
                    validateUPassword === false && (
                      <span>{error?.password2}</span>
                    )
                  )}
                </div>
                <div>
                  <label>Confirm password* </label>
                  <div className="form-password">
                    <input
                      type={`${showPassword.confirmPassword ? "text" : "password"
                        }`}
                      name="confirmPassword"
                      value={details.confirmPassword}
                      onChange={handleInputChange}
                      style={{ padding: "7px" }}
                    />
                    <i
                      onClick={() => handlePassword("confirmPassword")}
                      className={`icon ${showPassword.confirmPassword
                        ? "icon-view-password-active"
                        : "icon-view-password"
                        }`}
                    ></i>
                  </div>
                  {error?.confirmPassword && (
                    <span>{error?.confirmPassword}</span>
                  )}
                </div>
              </div>

              <div className="purchaseRegistration">
                <div>
                  <label>Country* </label>
                  <select
                    name="country"
                    onChange={handleInputChange}
                    style={{ padding: "7px" }}
                  >
                    <option hidden>Select</option>
                    {countryData?.map((country) => (
                      <option value={country.name}>{country.country}</option>
                    ))}
                  </select>
                  {!details?.country && <span>{error?.country}</span>}
                </div>

                <div>
                  <label>State/Province* </label>
                  <select
                    name="state"
                    onChange={handleInputChange}
                    style={{ padding: "7px" }}
                  >
                    <option>Select</option>
                    {countryData.map((items) => {
                      if (items.country === details.country) {
                        return items.states.map((element) => (
                          <option value={element}>{element}</option>
                        ));
                      }
                    })}
                  </select>

                  {!details?.state && <span>{error?.state}</span>}
                </div>
              </div>

              <div className="purchaseRegistration">
                <div>
                  <label>Organisation name* </label>
                  <input
                    type="text"
                    name="OrganisationName"
                    value={details.OrganisationName}
                    onChange={handleInputChange}
                    style={{ padding: "7px" }}
                  />
                  {!details?.OrganisationName && (
                    <span>{error?.organisationName}</span>
                  )}
                </div>
                <div>
                  <label>Organisation type* </label>
                  <select
                    name="OrganisationType"
                    onChange={handleInputChange}
                    style={{ padding: "7px" }}
                  >
                    <option>Select</option>
                    <option value="Independent Teacher">
                      Independent Teacher
                    </option>
                    <option value="Primary School">Primary School</option>
                    <option value="Charter School">Charter School</option>
                    <option value="University or college">
                      University or college
                    </option>
                    <option value="Charity">Charity</option>
                    <option value="Government">Government</option>
                    <option value="Other">Other</option>
                  </select>
                  {!details?.OrganisationType && (
                    <span>{error?.OrganisationType}</span>
                  )}
                </div>
              </div>

              <div className="purchaseRegistration">
                <div>
                  <label>Mobile/Cell number* </label>
                  <input
                    type="text"
                    name="phoneNumber"
                    value={details.phoneNumber}
                    onChange={(e) => {
                      handleInputChange(e);
                      validateUserPhoneNumber(e);
                    }}
                    style={{ padding: "7px" }}
                  />
                  {!details.phoneNumber ? (
                    <span>{error?.phoneNumber}</span>
                  ) : (
                    validateUPhoneNumber === false && (
                      <span>{error?.phoneNumber2}</span>
                    )
                  )}{" "}
                </div>

                <div>
                  <label>City* </label>
                  <input
                    type="text"
                    name="city"
                    value={details.city}
                    onChange={handleInputChange}
                    style={{ padding: "7px" }}
                  />
                  {!details?.city && <span>{error?.city}</span>}
                </div>
              </div>

              <div className="purchaseRegistration">
                <div>
                  <label>Postal/zip code* </label>
                  <input
                    type="text"
                    name="pincode"
                    value={details.pincode}
                    onChange={handleInputChange}
                    style={{ padding: "7px" }}
                  />
                  {!details?.pincode && <span>{error?.pincode}</span>}
                </div>
                <div>
                  <label>Street Address* </label>
                  <input
                    type="text"
                    name="street"
                    value={details.street}
                    onChange={handleInputChange}
                    style={{ padding: "7px" }}
                  />
                  {!details?.street && <span>{error?.street}</span>}
                </div>
              </div>

              <div className="purchaseRegistration">
                <div>
                  <label>Your Role</label>
                  <select
                    name="role"
                    onChange={handleInputChange}
                    style={{ padding: "7px" }}
                  >
                    <option>Select</option>
                    <option value={3}>Enterprise</option>
                  </select>
                  {!details?.role && <span>{error?.role}</span>}
                </div>
              </div>
              <div>
                {!isLoading ? (
                  <div className="flex-ew-1">
                    <input
                      type="checkbox"
                      checked={checkLicense}
                      onChange={handleAccept}
                      id="one"
                      style={{ width: "auto" }}
                    />
                    <label htmlFor="one">
                      I agree to the Terms and Conditions of Contract.
                    </label>
                  </div>
                ) : (
                  <Loading />
                )}
                {!load && (
                  <button onClick={validate} className="quiz-submit-btn">
                    Submit
                  </button>
                )}
                {load && <Loading></Loading>}
              </div>
            </div>
          )}
        </div>

        {printCertificate && (
          <ChapterDocument
            type={"pdf"}
            url={licenseData}
            closeHandler={showHandler}
            show={printCertificate}
          />
        )}
      </OverlayContainer>
      {popUp && (
        <SignupOverlay
          setVerificationModal={setPopUp}
          verificationModal={popUp}
          email={details.email}
        />
      )}
    </div>
  );
};

export default ConfirmationModal;
